<div class="submit-form" style="margin-bottom: 20px;">
  <div>
    <h3 *ngIf="isAdmin && !isEdit" class="title-page text-primary"> Phản hồi </h3>
    <h3 *ngIf="!isAdmin" class="title-page text-primary"> Thông tin phản hồi </h3>
    <div *ngIf="!isEdit" class="mb-3">
      <label class="form-label" for="verifyName">Người kiểm tra</label>
      <input class="form-control" [disabled]="!isAdmin" id="verifyName" required
        [(ngModel)]="registrationVerify.verifyName" name="verifyName" />
    </div>
    <div *ngIf="!isEdit" class="mb-3">
      <label class="form-label" for="feedbackInformation">Thông tin</label>
      <input class="form-control" [disabled]="!isAdmin" id="feedbackInformation" required
        [(ngModel)]="registrationVerify.feedbackInformation" name="feedbackInformation" />
    </div>
    <div *ngIf="isAdmin && !isEdit" class="col-md-2">
      <button (click)="sendFeedback()" class="btn btn-success">Gửi phản hồi</button>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h3 class="title-page text-primary">Thông tin tờ khai đã đăng ký</h3>
      </div>
      <div class="col-md-6" style="text-align: right; margin-top: 15px;">
        <button *ngIf="!isEdit && isAdmin" (click)="isEdit = true" class="btn btn-light"><i
            class="fa fa-pencil-square-o" aria-hidden="true"></i> Chỉnh sửa thông tin tờ khai</button>
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="declarationNumber">Số tờ khai</label>
      <input type="text" [readonly]="!isEdit" class="form-control" id="declarationNumber"
        [(ngModel)]="registrationVerify.declarationNumber" name="Số tờ khai" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="codeType">Mã loại hình</label>
      <input class="form-control" [readonly]="!isEdit" id="codeType" [(ngModel)]="registrationVerify.codeType"
        name="codeType" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="enterpriseName">Tên doanh nghiệp</label>
      <input class="form-control" [readonly]="!isEdit" id="enterpriseName"
        [(ngModel)]="registrationVerify.enterpriseName" name="enterpriseName" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="productName">Tên hàng hóa</label>
      <input class="form-control" [readonly]="!isEdit" id="productName" [(ngModel)]="registrationVerify.productName"
        name="productName" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="countProduct">Số lượng cont/hàng rời</label>
      <input class="form-control" [readonly]="!isEdit" id="countProduct" [(ngModel)]="registrationVerify.countProduct"
        name="countProduct" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="address">Địa điểm kiểm tra thực tế hàng hóa</label>
      <input class="form-control" [readonly]="!isEdit" id="address" [(ngModel)]="registrationVerify.address"
        name="address" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="expectedDeliveryDate">Ngày dự kiến xuất trình hàng</label>
      <input class="form-control" [readonly]="!isEdit" id="expectedDeliveryDate"
        [(ngModel)]="registrationVerify.expectedDeliveryDate" name="expectedDeliveryDate" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="expectedDeliveryHour">Giờ dự kiến xuất trình hàng</label>
      <input class="form-control" [readonly]="!isEdit" id="expectedDeliveryHour"
        [(ngModel)]="registrationVerify.expectedDeliveryHour" name="expectedDeliveryHour" />
    </div>
    <h5>Thông tin người xuất trình hàng hóa (Nhận phản hồi)</h5>
    <div class="mb-3">
      <label class="form-label" for="receiverName">Họ và tên</label>
      <input class="form-control" [readonly]="!isEdit" id="receiverName" [(ngModel)]="registrationVerify.receiverName"
        name="receiverName" />
    </div>
    <div class="mb-3">
      <label class="form-label" for="receiverPhone">Số điện thoại</label>
      <input class="form-control" [readonly]="!isEdit" id="receiverPhone" [(ngModel)]="registrationVerify.receiverPhone"
        name="receiverPhone" />
    </div>
    <div *ngIf="isAdmin && isEdit" class="col-md-6">
      <button (click)="sendFeedback()" class="btn btn-primary">Cập nhật thông tin tờ khai</button>
      <button style="margin-left: 5px;" (click)="cancel()" class="btn btn-light">Hủy bỏ</button>
    </div>
    <div class="mb-3">
      <label class="form-label" for="note">Ghi chú</label>
      <textarea class="form-control" [readonly]="!isEdit" id="note" rows="4" cols="50"
        [(ngModel)]="registrationVerify.note" name="note"> </textarea>
    </div>
  </div>
</div>
